import React, { PropsWithChildren } from 'react';
import { MeatballMenu } from 'ui';

import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { toUpdateSavedReport } from 'app/area/shared/navigation';

import { SavedReportsTranslation } from '../../constants';
import { GenericSavedReport, SavedReportsValidation } from '../../types-store';
import { UpdateSavedReportHandler } from '../../types';
import { SavedReportTileConfig } from '../types';

interface SavedReportMeatballProps<SavedReport extends GenericSavedReport> {
  savedReport: SavedReport;

  prevElementSequence: number;
  nextElementSequence: number;

  onAddReports: (sequence?: number) => void;
  onAddById: (sequence?: number) => void;

  updateSavedReport: UpdateSavedReportHandler<SavedReport>;
  deleteSavedReport: (savedReportId: number) => void;
  deleteAllSavedReports: () => void;

  onHideDetails: () => void;

  validation: SavedReportsValidation<SavedReport>;
  translation: SavedReportsTranslation;
  tileConfig: SavedReportTileConfig;
}

export const SavedReportMeatball = <SavedReport extends GenericSavedReport>({
  savedReport, prevElementSequence, nextElementSequence,
  onAddReports, onAddById, updateSavedReport, deleteSavedReport, onHideDetails, deleteAllSavedReports,
  validation, translation, tileConfig
}: PropsWithChildren<SavedReportMeatballProps<SavedReport>>) => {

  const onEditReport = () => {
    toUpdateSavedReport(savedReport.code?.value, true);
  };

  const addReportsHandler = () => {
    onAddReports(savedReport.sequence);
  };

  const addByIdHandler = () => {
    onAddById(savedReport.sequence);
  };

  const onMoveUp = () => {
    updateSavedReport(savedReport.code?.value,
      { ...savedReport, sequence: prevElementSequence },
      validation[savedReport?.code?.value]);
  };

  const onMoveDown = () => {
    updateSavedReport(savedReport.code?.value,
      { ...savedReport, sequence: nextElementSequence },
      validation[savedReport?.code?.value]);
  };

  const onRemove = () => {
    deleteSavedReport(savedReport.code?.value);
  };

  if (!tileConfig) {
    return null;
  }

  return <MeatballMenu closeAfterClick={true} onExpandMenu={onHideDetails}>
    {!!savedReport.editable && tileConfig.edit && <li>
      <button className="dropdown-item"
        onClick={onEditReport}>
        {translation.edit_report}
      </button>
    </li>}
    {tileConfig.add && <li>
      <button className="dropdown-item"
        onClick={addReportsHandler}>
        {translation.add_reports}
      </button>
    </li>}
    {tileConfig.add && <li>
      <button className="dropdown-item"
        onClick={addByIdHandler}>
        {translation.add_report_by_id}
      </button>
    </li>}
    {isDefinedIncludingZero(prevElementSequence) && tileConfig.move && <li>
      <button className="dropdown-item"
        onClick={onMoveUp}>
        {translation.move_up}
      </button>
    </li>}
    {isDefinedIncludingZero(nextElementSequence) && tileConfig.move && <li>
      <button className="dropdown-item"
        onClick={onMoveDown}>
        {translation.move_down}
      </button>
    </li>}
    {tileConfig.delete && <li>
      <button className="dropdown-item"
        onClick={onRemove}>
        {translation.remove}
      </button>
    </li>}
    {tileConfig.delete && <li>
      <button className="dropdown-item"
        onClick={deleteAllSavedReports}>
        {translation.remove_all}
      </button>
    </li>}
  </MeatballMenu>;
};
